import { appLocalStorage } from './storage';

export const oauthAttemptKey = provider => `wiw.oauth-consent.${provider}`;
export const socialAttemptKey = provider => `wiw.social-auth.${provider}`;

// A persisted callback can arrive after a different provider completed login,
// even in a new document. Only attempts from the current session may survive.
export function discardAuthAttempts() {
  [oauthAttemptKey('google'), oauthAttemptKey('apple'), socialAttemptKey('tiktok'), socialAttemptKey('discord')]
    .forEach(key => appLocalStorage.removeItem(key));
}
